import { processName } from "../../utils/adaByron";
import { api } from "../../utils/monitoringUtils";
import { Context, MethodType } from "../../utils/types";
import Request, { getMockedInfo } from "../../utils/request";
import Sonda from "../../utils/sonda";

export enum PATHS {
  DECREASE_STOCK = "/api/terminal/v1/sub",
}

/**
 * Promise que reduce el stock de un terminal
 * @param data información para identificar el terminal
 * @param context contexto de la aplicacion
 * @param idFront identificador unico para las petiticiones
 * @returns json de backup
 */
export const decreaseStock = (
  data: {
    productOffering: string;
    idColor: string;
    idCapacidad: string;
  },
  context: Context,
  idFront = "VT"
): Promise<unknown> => {
  const idRequest = api.getUUID(idFront);
  const sonda = new Sonda({
    eventName: "PAC.DECREASE_STOCK",
    context,
    uniqueId: idRequest,
    origin: processName,
  });

  const { catalogue: connectionData, name } = context.environment;
  const { endpoint: host, headers } = connectionData;
  const { productOffering, idColor, idCapacidad } = data;

  const URL_API = `${host}${PATHS.DECREASE_STOCK}?${idRequest}&productOffering=${productOffering}&idColor=${idColor}&idCapacidad=${idCapacidad}`;

  const mockInfo = getMockedInfo("decreaseStock", name);
  try {
    const request = new Request({
      method: MethodType.GET,
      endpoint: URL_API,
      sonda,
      headers,
      mockInfo,
    });

    return request.makeRequest();
  } catch (err) {
    sonda.errorJs(err);
    return null;
  }
};
